import React, { Component } from 'react'
import { Input } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { __ } from '../services/translate'
import { getQueryParam } from '../utils/url'
import { searchCleared, setQuery } from '../actions/app'
import { connect } from 'react-redux'

class SearchInput extends Component {

  state = {
    q: ''
  }

  onChange = (e) => this.setState({ q: e.target.value })

  componentDidMount() {
    const q = getQueryParam(this.props.location.search, 'q')
    if (q) {
      this.setState({ q })
      this.props.setQuery(q)
    }
  }

  static getDerivedStateFromProps(props) {
    if (props.shouldClear) {
      props.cleared()
      return {
        q: ''
      }
    }
    return null
  }

  keyPress = (e) => {
    const { q } = this.state
    if (e.key === 'Enter' && q.trim() && q.length >= 3) {
      this.props.setQuery(q)
      this.props.history.push(`/search/?q=${encodeURIComponent(q)}`)
    }
  }

  render() {
    return (
      <Input
        type="text"
        placeholder={__('Hledat')}
        onChange={this.onChange}
        onKeyPress={this.keyPress}
        value={this.state.q}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  q: state.app.searchQuery,
  shouldClear: state.app.shouldClear,
})

const mapDispatchToProps = (dispatch) => ({
  setQuery: (q) => dispatch(setQuery(q)),
  cleared: () => dispatch(searchCleared())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchInput))
